import { Globe, ShoppingCart, Search, Wrench, Smartphone, BarChart3 } from "lucide-react";
import { AnimateIn } from "@/hooks/useAnimations";
import { scrollToSection } from "@/lib/scrollToSection";

const services = [
  { icon: Globe, title: "Custom Website Design", desc: "Tailor-made websites designed from scratch to match your brand identity and business goals. No cookie-cutter templates." },
  { icon: ShoppingCart, title: "E-Commerce Solutions", desc: "Online stores with secure payment gateways (Razorpay, UPI), inventory management, and order tracking for Indian businesses." },
  { icon: Search, title: "SEO Optimization", desc: "Get found on Google. We optimize your site for search engines so customers in your city find you first." },
  { icon: Smartphone, title: "Mobile-First Design", desc: "Over 70% of Indian users browse on mobile. Every site we build is perfectly responsive across all devices." },
  { icon: Wrench, title: "Website Maintenance", desc: "Ongoing support, security updates, content changes, and performance monitoring to keep your site running smooth." },
  { icon: BarChart3, title: "Digital Strategy", desc: "Complete digital growth plans including Google My Business setup, social media integration, and analytics tracking." },
];

export default function ServicesSection() {
  return (
    <section id="services" data-testid="services-section" className="py-14 sm:py-20 lg:py-24 bg-[#111111] relative grid-lines scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <AnimateIn>
          <div className="text-center mb-10 sm:mb-16">
            <span className="text-4xl sm:text-6xl font-black text-red-600/10 block mb-1 sm:mb-2">02</span>
            <p className="section-label text-[10px] sm:text-xs font-bold tracking-[0.2em] uppercase text-red-600 justify-center">What We Do</p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black uppercase tracking-tight">
              Our <span className="text-red-600">Services</span>
            </h2>
            <div className="section-divider"></div>
          </div>
        </AnimateIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((service, i) => (
            <AnimateIn key={service.title} delay={0.18 * i} direction={i % 2 === 0 ? "left" : "right"}>
              <div
                data-testid={`service-card-${i}`}
                className="card-accent card-top-bar group border border-white/10 bg-[#0A0A0A] p-5 sm:p-8 hover:border-red-600/70 transition-all duration-300 hover:-translate-y-2 hover:shadow-[8px_8px_0_0_rgba(229,9,20,0.85)] cursor-pointer h-full"
              >
                <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-5">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-600/10 flex items-center justify-center group-hover:bg-red-600 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shrink-0">
                    <service.icon size={18} className="text-red-500 group-hover:text-white transition-colors duration-300 sm:hidden" />
                    <service.icon size={22} className="text-red-500 group-hover:text-white transition-colors duration-300 hidden sm:block" />
                  </div>
                  <h3 className="text-sm sm:text-base font-bold uppercase tracking-tight text-white group-hover:text-red-500 transition-colors duration-300">{service.title}</h3>
                </div>
                <p className="text-xs sm:text-sm text-zinc-400 leading-relaxed">{service.desc}</p>
                <div className="mt-3 sm:mt-5 pt-3 sm:pt-4 border-t border-white/5">
                  <button
                    onClick={() => document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'})}
                    data-testid={`service-cta-${i}`}
                    className="link-underline text-[10px] font-bold uppercase tracking-widest text-red-600 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 inline-block cursor-pointer"
                  >
                    Get This Service &rarr;
                  </button>
                </div>
              </div>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}
